// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    grandCompte: "nicoll",
    main_title: "Configurateur de gouttière et débord de toit",
    main_subtitle: "Configurez votre projet et recevez une étude détaillée par mail",
    api_configurateur_url: "https://api-configurateur.nicoll.fr",
    user_nicoll_url: "https://www.nicoll.fr/configurator/user/",
    configurateur_url: "https://configurateur.nicoll.fr",
    external_account_url: "",
    already_user_url: "https://www.nicoll.fr/connect?nicoll_redirect_url=https://configurateur.nicoll.fr/contact",
    show_search_magasin: false,
    landmarks_bg_color: "#e2202b",
    need_authentication: false,
    ws_authentication_url: "",
    has_contact_form: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts